import { Modal } from "react-bootstrap";
import ModifierCategoryChildProductCombo from "./ModifierCategoryChildProductCombo.js";
import ErrorAlert from "../../../../common/ui/ErrorAlert.js";
import * as CommonUtilities from "../../../../common/utils/CommonUtils.js";

export default function ProductComboChildModalPage(props) {
    // Details of Product that will be added into a group within a Product Combo

    /* ⚠ Bulk pricing hides BOTH the per-item price and the special-instructions
       box. That is a deliberate gate from the live code, not styling:

         price         a bulk order is priced on quantity breaks, so a single
                       item's price is misleading
         instructions  a bulk order form has no per-line kitchen note

       The redesign dropped the gate and showed both to every brand. Restored. */
    const isBulkPricing = CommonUtilities.StaticFields.PriceType === 'bp8826';

    let instrIsInvalid = "";
    if (props.productComboChildFormData.validation.SpecialInstructions.HasError) {
        instrIsInvalid = "is-invalid";
    } else {
        instrIsInvalid = "";
    }

    let energyCount;
    if (props.productComboChildDetails.selectedProductDetails.selectedProductInGroup.energyCount !== 0 && props.productComboChildDetails.selectedProductDetails.selectedProductInGroup.energyCount !== "0" && props.productComboChildDetails.selectedProductDetails.selectedProductInGroup.energyCount !== "" && props.productComboChildDetails.selectedProductDetails.selectedProductInGroup.energyCount !== null) {
        energyCount = <span className="wo-pm__kj">{props.productComboChildDetails.selectedProductDetails.selectedProductInGroup.energyCount}kJ</span>
    } else {
        energyCount = <></>
    }


    let modifierCategories;
    modifierCategories = props.productComboChildDetails.selectedProductDetails.selectedProductInGroup.modCategories?.map((item) => {
        return (
            <ModifierCategoryChildProductCombo 
                key={item.modCategoryId}
                modifierCategoryDetails={item}
                handleProductComboModFormChange={props.handleProductComboModFormChange}
                productComboChildFormData={props.productComboChildFormData}
                productFormDataMods={props.productComboChildFormData.data.Mods} // Passing as productFormDataMods from productComboChildFormData
                productFormDataModCatValidation={props.productComboChildFormData.validation.ModCategories} // Passing as productFormDataModCatValidation
                addToProductComboError={props.addToProductComboError}
                currentLocation={props.currentLocation}
                priceInc={props.productComboChildDetails.selectedProductDetails.selectedProductInGroup.priceInc}
            />
        )
    });

    const product = props.productComboChildDetails.selectedProductDetails.selectedProductInGroup;
    const hasImage = !!product.productImageURL;
    /* Compact header, same reasoning as the parent product screen: this page
       is reached specifically to configure modifiers, so the photo must not
       push them below the fold. */
    const hasOptions = (product.modCategories || []).length > 0;

    // Gate — all three conditions, as the original. Computed once, used twice.
    const canOrder = props.currentLocation.AllowOnlineOrder
        && props.currentLocation.Validation.IsValidTableNumber
        && !props.productComboChildDetails.selectedProductDetails.isSoldOut;

    return(
        <>
            <Modal.Body className="wo-pm__body">
                {hasImage && !hasOptions &&
                    <div className="wo-pm__hero">
                        <img src={product.productImageURL} alt={product.productName} loading="lazy" decoding="async" />
                    </div>}

                <div className={`wo-pm__intro${hasOptions ? ' wo-pm__intro--compact' : ''}`}>
                    {hasImage && hasOptions &&
                        <span className="wo-pm__thumb">
                            <img src={product.productImageURL} alt={product.productName} loading="lazy" decoding="async" />
                        </span>}
                    <div className="wo-pm__introText">
                        <div className="wo-pm__nameRow">
                            <h3 className="wo-pm__name">{product.productName}</h3>
                            {energyCount}
                        </div>
                        {product.productDescription && <p className="wo-pm__desc">{product.productDescription}</p>}
                        {!isBulkPricing &&
                            <p className="wo-pm__price">${product.priceInc && product.priceInc.toFixed(2)}</p>}
                    </div>
                </div>

                <div className="wo-pm__options row g-0">
                    {modifierCategories}
                </div>

                { canOrder && !isBulkPricing &&
                    <div className="wo-pm__instr">
                        <label htmlFor="txtareaSpecialInstr" className="wo-pm__instrLabel">Special Instructions</label>
                        <textarea className={`form-control wo-pm__instrBox ${instrIsInvalid}`} id="txtareaSpecialInstr" name="SpecialInstructions" rows="2" placeholder="Anything we should know?" value={props.productComboChildFormData.data.SpecialInstructions} onChange={props.handleProductComboChildFormChange} disabled={props.addToProductComboError.ButtonsDisabled} maxLength="32"></textarea>
                        <small className="wo-pm__instrHint">Up to 32 characters</small>
                        <small className="invalid-feedback">{props.productComboChildFormData.validation.SpecialInstructions.ErrorMessage}</small>
                    </div>
                }
            </Modal.Body>
            <Modal.Footer className="wo-pm__foot">
                { props.addToProductComboError.HasError && <div className="wo-pm__footErr"><ErrorAlert message={props.addToProductComboError.ErrorMessage} /></div> }
                { canOrder &&
                    <div className="wo-pm__footBar">
                        <button type="button" className="wo-pm__add" onClick={props.handleAddToProductCombo} disabled={props.addToProductComboError.ButtonsDisabled}>
                            Add to Combo
                            {props.addToProductComboError.ButtonsDisabled && <>&ensp;<span className="spinner-border spinner-border-sm" aria-hidden="true"></span></>}
                        </button>
                    </div>
                }
            </Modal.Footer>
        </>
    )
}